











import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import { DrawableObjectMixin, ObjectClipboardMixin } from "../objects/mixins";

@Component
export default class ShapeObjectMenu extends Mixins(ObjectClipboardMixin) {
  @Prop()
  source: Vue & DrawableObjectMixin;

  get isErasable(): boolean {
    return this.$store.getters.configuration.behavior.document.editor.eraser.isEnable
        && this.source.isImageConvertible;
  }

  get isObjectCopyable(): boolean {
    return this.getObjectCopyable(this.source.editingSource);
  }

  async eraseConvertedImage(): Promise<void> {
    this.source.eraseConvertedImage();
  }

  copySourceToObjectClipboard() {
    this.copyToObjectClipboard(this.source.editingSource);
  }
}
